import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { VerificationResultSchema, PaginationQuerySchema, PaginationMetaSchema, DateRangeQuerySchema, ErrorResponseSchema, } from './schemas';
const c = initContract();
export const verificationsContract = c.router({
    list: {
        method: 'GET',
        path: '/verifications',
        query: PaginationQuerySchema.merge(DateRangeQuerySchema).extend({
            employeeId: z.string().optional(),
            state: z
                .enum([
                'pending',
                'verified_green',
                'verified_yellow',
                'flagged_red',
                'reverified',
                'manually_reviewed',
                'missing',
            ])
                .optional(),
        }),
        responses: {
            200: z.object({
                success: z.literal(true),
                data: z.array(VerificationResultSchema),
                meta: PaginationMetaSchema.optional(),
            }),
            401: ErrorResponseSchema,
        },
        summary: 'List verifications with filters',
    },
    getById: {
        method: 'GET',
        path: '/verifications/:verificationId',
        pathParams: z.object({
            verificationId: z.string(),
        }),
        responses: {
            200: z.object({
                success: z.literal(true),
                data: VerificationResultSchema,
            }),
            401: ErrorResponseSchema,
            404: ErrorResponseSchema,
        },
        summary: 'Get verification by ID',
    },
    reverify: {
        method: 'POST',
        path: '/verifications/reverify',
        body: z.object({
            employeeId: z.string(),
            startDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
            endDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
        }),
        responses: {
            202: z.object({
                success: z.literal(true),
                data: z.object({ message: z.string() }),
            }),
            400: ErrorResponseSchema,
            401: ErrorResponseSchema,
        },
        summary: 'Request re-verification for an employee and date range',
    },
});
//# sourceMappingURL=verifications.js.map